var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_9860_20325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.96 10.815C15.08 9.65505 17.88 6.79505 20.45 3.99505L20.69 3.73505L20.86 3.49505C21.11 3.10505 21.01 2.97505 20.74 2.61505C20.33 2.05505 20.42 2.13505 19.83 1.75505C19.6 1.60505 19.31 1.52505 19.04 1.58505C18.76 1.65505 18.67 1.70505 18.47 1.90505C18.27 2.11505 15.97 4.47505 11.54 8.57505C11.54 8.57505 9.21002 10.635 7.84002 8.39505C5.57002 4.65505 4.96002 2.55505 4.10002 0.925049C3.95002 0.645049 3.77002 0.535049 3.68002 0.535049C3.49002 0.505049 3.11002 0.475049 2.79002 0.575049C1.99002 0.845049 1.62001 1.43505 0.980015 1.97505C0.570015 2.32505 0.390015 2.43505 0.660015 2.90505C1.97001 5.27505 4.64002 10.445 5.14002 11.325C7.29002 15.115 11.59 13.255 13.95 10.805L13.96 10.815Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9860_20325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.99,
    height: 20.46,
    fill: "white",
    transform: "matrix(0 1 -1 0 21 0.505005)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.7cf029316ae72dbd0cebf6bfad80b4ec.svg";
export { ForwardRef as ReactComponent };